import React from 'react';

import Svg, { G, Path } from '@dbk/ui-svg';

const ListView = ({fill = '#A7A8AA', width = 24, height=25}) => (
  <Svg width={width} height={height} viewBox="0 0 24 25">
    <G fill="none" fillRule="evenodd">
      <Path fill={fill} d="M11.685931,1.25853448 C5.90937931,1.25853448 1.20786207,6.15508621 1.20786207,12.1723276 C1.20786207,18.190431 5.90937931,23.0869828 11.685931,23.0869828 C17.4624828,23.0869828 22.1631724,18.190431 22.1631724,12.1723276 C22.1631724,6.15508621 17.4624828,1.25853448 11.685931,1.25853448 M11.685931,24.3447414 C5.24151724,24.3447414 0.000413793103,18.8852586 0.000413793103,12.1723276 C0.000413793103,5.46025862 5.24151724,-8.62068963e-05 11.685931,-8.62068963e-05 C18.1295172,-8.62068963e-05 23.3714483,5.46025862 23.3714483,12.1723276 C23.3714483,18.8852586 18.1295172,24.3447414 11.685931,24.3447414 Z"/>
      <Path stroke={fill} strokeLinecap="round" strokeLinejoin="round" d="M9.84 8.125L16.56 8.125M9.84 11.875L16.56 11.875M9.84 15.625L16.56 15.625M6.24 8.125L6.252 8.125M6.24 11.875L6.252 11.875M6.24 15.625L6.252 15.625 Z"/>
    </G>
  </Svg>
);

export default ListView;
